export const convertFromPixels = (
  value: number,
  toUnits: string,
  dimensions: { width: number; height: number },
) => {
  if (toUnits === 'vh') {
    return (100 * value) / dimensions.height;
  }
  if (toUnits === 'vw') {
    return (100 * value) / dimensions.width;
  }
  return value;
};

// Guard: accept only string | number values for positional/transform props. Fall back to the default when the value is neither string nor number.
export const scalar = <T>(
  value: unknown,
  fallback: T,
): T extends string ? string : T => {
  if (typeof value === 'string' || typeof value === 'number') {
    return value as any;
  }
  return fallback as any;
};
